var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconValues = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 23,
  viewBox: "0 0 32 33.4"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "m31.5 7.1-7-6.7c-.6-.6-1.6-.6-2.3.1l-1.1 1.2 1.2 1.1L21.2 4 20 2.9 19 4l2.4 2.2-1.1 1.2L18 5.1l-1.1 1.2 1.2 1.1L17 8.6l-1.2-1.1-1.1 1.2L17 11l-1.2 1.3-2.3-2.3-1.1 1.2 1.2 1.1-1.1 1.2-1.2-1.1-1.1 1.1 2.3 2.2-1.1 1.2-2.3-2.2L8 15.8l1.2 1.1-1.1 1.2L7 17l-1.1 1.1 2.4 2.2-1.1 1.2-2.3-2.2-1.1 1.1 1.1 1.1-1.1 1.2-1.1-1.1-1.1 1.2L4 25l-1.1 1.2L.4 24s-1 1.2.1 2.3l7 6.7c.6.6 1.6.6 2.3-.1L31.6 9.4c.6-.7.5-1.7-.1-2.3z"
})));
export default SvgIconValues;